import { useState } from "react"
import { HistoricalInfo, PaginatedDJResponse } from "../types"
import { Typography, Stack, Box, Dialog, DialogTitle, DialogContent } from "@mui/material"
import { useTranslation } from "react-i18next"
import FormatDate from "./FormatDate"
import { UseInfiniteQueryResult, InfiniteData } from "@tanstack/react-query"

type RecordInfoProps = {
  first_update: HistoricalInfo | undefined
  last_update: HistoricalInfo | undefined
  historyBag?: UseInfiniteQueryResult<InfiniteData<PaginatedDJResponse<HistoricalInfo>, unknown>, Error>
}

export default function RecordInfo({ first_update, last_update, historyBag }: RecordInfoProps) {
  const { t } = useTranslation()
  const [showHistory, setShowHistory] = useState(false)

  return (
    <Box>
      <Box>
        {/* <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <Avatar sx={{ bgcolor: "grey.700" }} variant="rounded">
            <Info />
          </Avatar>
          <Typography variant="h6">{t("sections.info")}</Typography>
        </Stack> */}
        {first_update && last_update ? (
          <>
            <Stack>
              <Typography variant="subtitle2" component="h3">
                {t("sections.record_created")}
              </Typography>
              <Typography variant="body1">
                <FormatDate>{first_update.history_date}</FormatDate> - {first_update.full_name}
              </Typography>
            </Stack>
            <Stack>
              <Typography variant="subtitle2" component="h3">
                {t("sections.record_last_update")}
              </Typography>
              <Typography variant="body1">
                <FormatDate>{last_update.history_date}</FormatDate> - {last_update.full_name}
              </Typography>
            </Stack>
          </>
        ) : (
          <Typography variant="body1">{t("sections.no_info")}</Typography>
        )}
        <Stack sx={{ mt: 1 }}>
          <Typography
            variant="subtitle2"
            component="h3"
            onClick={() => setShowHistory(true)}
            sx={{ cursor: "pointer" }}
          >
            {t("sections.show_history")}
          </Typography>
        </Stack>
      </Box>
      <Dialog open={showHistory} onClose={() => setShowHistory(false)} scroll="paper">
        <DialogTitle>{t("sections.history")}</DialogTitle>
        <DialogContent>
          {historyBag?.data?.pages?.map((page: any) => {
            return (
              page &&
              page.results.map((history: HistoricalInfo) => (
                <Stack key={history.history_date}>
                  <Typography variant="body1" component="h3">
                    <FormatDate>{history.history_date}</FormatDate> - {history.full_name}
                  </Typography>
                </Stack>
              ))
            )
          })}
          {historyBag?.hasNextPage && (
            <Stack onClick={() => historyBag.fetchNextPage()} sx={{ cursor: "pointer" }}>
              <Typography variant="body1" component="span">
                {t("sections.loading_more")}
              </Typography>
            </Stack>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  )
}
